import { CodeChangesPanel, type CodeChangesPanelRef } from "@/routes/environments/details/CodeChangesPanel";
import { GitStatusPanelCompact } from "@/routes/environments/details/GitStatusPanelCompact";
import { forwardRef, useImperativeHandle, useRef } from "react";

export type EnvironmentChangesViewRef = {
    scrollToFile: (filePath: string) => void;
    openFile: (filePath: string) => void;
};

export type EnvironmentChangesViewProps = {
    environmentId: string;
};

export const EnvironmentChangesView = forwardRef<EnvironmentChangesViewRef, EnvironmentChangesViewProps>(
    ({ environmentId }, ref) => {
        const codeChangesPanelRef = useRef<CodeChangesPanelRef>(null);

        useImperativeHandle(ref, () => ({
            scrollToFile: (filePath: string) => {
                codeChangesPanelRef.current?.scrollToFile(filePath);
            },
            openFile: (filePath: string) => {
                codeChangesPanelRef.current?.openFile(filePath);
            },
        }), []);

        return (
            <div className={"flex grow flex-col gap-2 @container"} data-testid="environment-changes-view">
                <GitStatusPanelCompact environmentId={environmentId} />
                <CodeChangesPanel
                    ref={codeChangesPanelRef}
                    environmentId={environmentId}
                />
            </div>
        );
    },
);
EnvironmentChangesView.displayName = "EnvironmentChangesView";
